import * as React from 'react';
import { Query } from 'react-apollo';

import COMPOSER_GROUPS_QUERY from 'chat/queries/ComposerGroupsQuery.gql';
import COMPOSER_ORGS_QUERY from 'chat/queries/ComposerOrgsQuery.gql';
import { ComposerOrgs } from 'chat/queries/__generated__/ComposerOrgs';
import { ComposerGroups } from 'chat/queries/__generated__/ComposerGroups';
import { Target } from 'entities/Message';

import { ComposerOrganization } from 'types/typescript/messagingTypes';
import { filterNull } from 'utils/tsUtils';

import ComposerDataLoader, { Props as DataLoaderProps } from './ComposerDataLoader';

type ChildProps = {
  groupsLoading?: boolean;
  orgsLoading?: boolean;
  schools?: ComposerOrganization[];
};

type Props = {
  initialTargets?: Target[];
  children: (props: ChildProps) => React.ReactElement;
};

const ComposerDataContainer = ({ initialTargets, children }: Props) => (
  <Query<ComposerOrgs> query={COMPOSER_ORGS_QUERY}>
    {({ data, loading: orgsLoading }) => {
      const orgs = data?.me?.organizations;
      const organizations =
        orgs && orgs.filter(o => o.type === 'District' && o.permissions.canSendAnnouncement);
      const schools =
        orgs && orgs.filter(o => o.type === 'School' && o.permissions.canSendAnnouncement);

      return (
        <Query<ComposerGroups> query={COMPOSER_GROUPS_QUERY}>
          {({ data, loading: groupsLoading }) => {
            const groups = filterNull(data?.me?.classes ?? []);
            const dataLoaderProps: DataLoaderProps = {
              groups,
              organizations,
              groupsLoading,
              orgsLoading,
              initialTargets,
            };
            return (
              <>
                <ComposerDataLoader {...dataLoaderProps} />
                {children({ schools, groupsLoading, orgsLoading })}
              </>
            );
          }}
        </Query>
      );
    }}
  </Query>
);

export default ComposerDataContainer;
